// wsClient.js
let ws = null;
let listeners = new Set();
let reconnectTimer = null;
let lastConfig = null;
let tokenExpired = false;
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 5;

export function ensureWS(url, token) {
  // Don't reconnect if token is expired - user needs to re-login
  if (tokenExpired) {
    console.log("[ws] token expired, not reconnecting. Please re-login.");
    return null;
  }

  lastConfig = { url, token };

  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    return ws;
  }

  ws = new WebSocket(url, token);

  ws.onopen = () => {
    console.log("[ws] singleton connected");
    reconnectAttempts = 0; // Reset on successful connection
  };

  ws.onmessage = (ev) => {
    try {
      const data = JSON.parse(ev.data);
      // Handle auth errors from server
      if (data.type === 'auth_error') {
        if (data.code === 'TOKEN_EXPIRED') {
          console.log("[ws] token expired, stopping reconnection");
          tokenExpired = true;
          clearTimeout(reconnectTimer);
          return;
        }
      }
    } catch {}
    listeners.forEach(fn => fn(ev));
  };

  ws.onerror = (e) => console.log("[ws] singleton error", e);

  ws.onclose = (event) => {
    // Check close reason for token expiration
    if (event.reason === 'Token expired' || event.reason === 'Invalid token') {
      console.log("[ws] closed due to auth issue, not retrying");
      tokenExpired = true;
      return;
    }

    // Limit reconnect attempts
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      console.log("[ws] max reconnect attempts reached, stopping");
      return;
    }

    reconnectAttempts++;
    const delay = Math.min(2000 * reconnectAttempts, 30000); // Exponential backoff, max 30s
    
    console.log(`[ws] singleton closed, retrying in ${delay/1000}s (attempt ${reconnectAttempts}/${MAX_RECONNECT_ATTEMPTS})`);
    clearTimeout(reconnectTimer);
    reconnectTimer = setTimeout(() => {
      ws = null;
      if (lastConfig && !tokenExpired) ensureWS(lastConfig.url, lastConfig.token);
    }, delay);
  };

  return ws;
}

// Reset token expired flag (call when user logs in with new token)
export function resetWsAuth() {
  tokenExpired = false;
  reconnectAttempts = 0;
  clearTimeout(reconnectTimer);
}

// Close WebSocket connection
export function closeWS() {
  clearTimeout(reconnectTimer);
  if (ws) {
    ws.close();
    ws = null;
  }
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
